import { createAsyncThunk } from '@reduxjs/toolkit';
import PackageApi from '@infrastructure/packages-api';
import { getErrorPayload } from '@application/common/helpers/api-helper';
export const getAllPackagesAsync = createAsyncThunk('packages/getAll', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PackageApi.getAllPackages();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
